const ENROLLMENT_DISCLOSURE_TYPES = Object.freeze({
    ENROLLMENT_APPLICANT: 'ENROLLMENT_APPLICANT',
    ENROLLMENT_ACCOUNT: 'ENROLLMENT_ACCOUNT'
});

export default ENROLLMENT_DISCLOSURE_TYPES;